(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
'use strict';

jQuery(document).ready(function ($) {
    var $form = $('#consentformfields-table');
    $form.find('table tbody').sortable({
        items: 'tr',
        handle: '.column-order',
        opacity: 0.6,
        cursor: 'move',
        axis: 'y',
        update: function update(event, ui) {
            var $item = ui.item,
                $items = $('#consentformfields-table table tr'),
                currentIndex = $items.index($item);
            var data = {
                field_id: $item.attr('id'),
                dest_field_id: 0,
                direction: '',
                action: $form.data('action'),
                nonce: $form.data('nonce')
            };
            if (currentIndex === 1) {
                // first
                data.direction = 'before';
                data.dest_field_id = $items.get(currentIndex + 1).getAttribute('id');
            } else {
                data.direction = 'after';
                data.dest_field_id = $items.get(currentIndex - 1).getAttribute('id');
            }
            $.ajax({
                data: data,
                url: $form.data('url'),
                type: 'post',
                dataType: "json"
            });
        }
    });

    var $tokensTable = $("#tokens-table");
    var $consentContainer = $("#consent-fields-container");
    console.log('loaded');
    if ($consentContainer.size() > 0) {
        $tokensTable.on('click', '.consent-fields-container button', function (e) {
            e.preventDefault();
            $(this).closest('tr').remove();
        });
        $tokensTable.find('tbody td.column-consent_data a').click(function (e) {
            e.preventDefault();
            var $this = $(this),
                $tr = $this.closest('tr'),
                $jsonContainer = $this.closest('td').find('div'),
                $mycontainer = $tr.next().find('.consent-fields-container');

            if ($mycontainer.size() > 0) {
                $mycontainer.closest('tr').remove();
            } else {
                console.log($this);
                console.log($jsonContainer);
                console.log($jsonContainer.text());
                var data = {};
                try {
                    data = JSON.parse($jsonContainer.text());
                } catch (ex) {}
                var $clone = $consentContainer.clone();
                $clone.addClass($clone.attr('id')).removeAttr('id');
                $clone.find('li').each(function () {
                    var $this = $(this),
                        fieldname = $this.data('fieldname');
                    if (data.hasOwnProperty(fieldname)) {
                        if (data[fieldname] === '1') {
                            $this.addClass('yes');
                        }
                    }
                });
                $tr.after($('<tr/>').append($('<td colspan="8"/>').append($clone)));
                $clone.show();
            }
        });
    }
});

},{}]},{},[1]);
